"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var TreeNodeIconWrapper = function TreeNodeIconWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      _classCallCheck(this, _class2);
      return _callSuper(this, _class2, arguments);
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "borderColor",
      get: function get() {
        if (this.finished) {
          return _constants.Theme.green;
        } else if (this.inProgress) {
          return _constants.Theme.orange;
        } else {
          return '#989898';
        }
      }
    }, {
      key: "color",
      get: function get() {
        if (this.finished) {
          return _constants.Theme.green;
        } else if (this.inProgress) {
          return _constants.Theme.orange;
        } else {
          return '#FFF';
        }
      }
    }, {
      key: "borderWidth",
      get: function get() {
        return _state.AppUI.layout.viewportWidth <= 549 ? 5 : 5;
      }
    }, {
      key: "hasAccess",
      get: function get() {
        return _state.AppUI.user.isMember || this.props.treeNode && this.props.treeNode.openAccess;
      }
    }, {
      key: "finished",
      get: function get() {
        return this.hasAccess && this.props.treeNode.treeNodeDecksCount > 0 && this.props.finishedUserDecksCount >= this.props.treeNode.treeNodeDecksCount;
      }
    }, {
      key: "nodeIsEnabled",
      get: function get() {
        return this.props.treeNode.webPublished && this.hasAccess || _state.AppUI.user.admin;
      }
    }, {
      key: "src",
      get: function get() {
        return (0, _utils.isPresent)(this.props.treeNode.image) && this.props.treeNode.image.url;
      }
    }, {
      key: "inProgress",
      get: function get() {
        return this.hasAccess && (0, _utils.isPresent)(this.props.userTreeNode) && this.props.finishedUserDecksCount < this.props.treeNode.treeNodeDecksCount;
      }
    }, {
      key: "showProgressCount",
      get: function get() {
        return this.props.finishedUserDecksCount < this.props.treeNode.treeNodeDecksCount;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          borderColor: this.borderColor,
          color: this.color,
          borderWidth: this.borderWidth,
          hasAccess: this.hasAccess,
          finished: this.finished,
          nodeIsEnabled: this.nodeIsEnabled,
          src: this.src,
          inProgress: this.inProgress,
          showProgressCount: this.showProgressCount
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "borderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "color", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "borderWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasAccess", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasAccess"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "finished", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "finished"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nodeIsEnabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nodeIsEnabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "src", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "src"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inProgress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showProgressCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showProgressCount"), _class2.prototype), _class2)) || _class;
};
TreeNodeIconWrapper.displayName = 'TreeNodeIconWrapper';
var _default = exports["default"] = TreeNodeIconWrapper;